import { PresentationApprovalRequestsTable_RequestFragment } from './graphql/PresentationApprovalRequestsTable.generated';

export interface PresentationApprovalRow {
  // The presentation ID. The table shows one row for each presentation.
  id: string;
  householdId: string;
  presentationName: string;
  clientName: string;
  requesterName: string;
  requestedAt: Date;
}

/**
 * getPresentationApprovalRows makes one row for each presentation from the
 * open approval requests to the current user. A user can have more than one
 * open request for a presentation. The requests come newest first, so the
 * newest request sets the row.
 */
export function getPresentationApprovalRows(
  requests: PresentationApprovalRequestsTable_RequestFragment[]
): PresentationApprovalRow[] {
  const rowsByPresentationId = new Map<string, PresentationApprovalRow>();

  for (const request of requests) {
    if (rowsByPresentationId.has(request.presentation.id)) {
      continue;
    }
    rowsByPresentationId.set(request.presentation.id, {
      id: request.presentation.id,
      householdId: request.household.id,
      presentationName: request.presentation.name,
      clientName: request.household.displayName,
      requesterName: request.user.displayName,
      requestedAt: request.createdAt,
    });
  }

  return Array.from(rowsByPresentationId.values());
}
